import React from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import router from "router/index";

class App extends React.Component {
  render() {
    return <RouterProvider router={router} />;
  }
}

export default App;
